import { isOnServer } from '@shared/constants/util'

/**
 *
 * @param {Function} func The function to wrap. Should return a Promise.
 * @returns {Function} A debounced function. Initial invocation returns a pending promise unless isOnServer is true then invocation(s) will not be debounced. Subsequent invocations coalesce and receive the pending function without executing the underlying function. Once the Promise settles, further invocations start the process again.
 */

export function safeAsyncDebounce<Args extends unknown[], R>(func: (...args: Args) => Promise<R>) {
  let locked: boolean, value: Promise<R> | undefined

  function lock(val: Promise<R>) {
    locked = true
    value = Promise.resolve(val).finally(unlock)
    return value
  }

  function unlock() {
    locked = false
    value = undefined
  }

  return function mutexedFunc(...args: Args): Promise<R> {
    // DO NOT DEBOUNCE ON THE SERVER!
    if (isOnServer()) return Promise.resolve(func(...args))
    if (locked) {
      return value!
    } else {
      return lock(func(...args))
    }
  }
}
